module.exports = __webpack_public_path__ + "img/progress_in.18e6caac.png";